import React, { useState, useEffect } from "react";
import { NewsDetailsWrapper } from "./NewsDetails.style";
import NewsDetailsBody from "./NewsDetailsBody";
import intersection from "lodash/intersection";
import { useHistory } from "react-router-dom";
import Api from "Helpers/ApiHandler";
import { useSelector } from "react-redux";
import { PAGE_NOT_FOUND } from "Helpers/Paths";
import { useNewsLocale } from '@fe-packages/components-and-utilities'

export default function NewsDetails() {
    const [newsArticleData, setNewsArticleData] = useState({});
    let history = useHistory();
    const language = useSelector(state => state.Auth.lang);

    useEffect(() => {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "smooth"
        });
        getNewsArticleData()
        // eslint-disable-next-line
    }, [language])
    const { extratNews } = useNewsLocale()

    const getNewsArticleData = async () => {
        let splitedLink = window.location.pathname.split('/')
        let id = splitedLink[splitedLink.length - 1]
        let response = await new Api().get(`games/news/${id}?field[]=images.img_microsite_background&field[]=author&field[]=updated&field[]=content&field[]=game_abbrs`, { skipAuth: true })

        let allGameAbbr = ["nw", "nwxb", "nwps"];
        if (!response.id || !(response?.game_abbrs && intersection(response.game_abbrs, allGameAbbr))) {
            history.replace(PAGE_NOT_FOUND)
        }

        setNewsArticleData(response)
        extratNews(response)
    }

    return (
        <React.Fragment>
            <NewsDetailsWrapper >
                <div className="bg-image"></div>
                <NewsDetailsBody newsArticleData={newsArticleData} getNewsArticleData={getNewsArticleData} />
            </NewsDetailsWrapper>
        </React.Fragment>

    )
}
